import { NavLink, Outlet } from "react-router-dom";
import { CUSTOMER_NAV } from "../../config/nav";
import { SiteHeader, Footer } from "./PublicLayout";

/* Customer account area rendered inside the public site chrome so the main public
   navigation stays visible after login (per pre-launch requirement #10). */
export default function CustomerLayout() {
  return (
    <div className="min-h-screen cf-bg cf-grain relative" style={{ overflowX: "clip" }}>
      <div className="relative z-10 flex flex-col min-h-screen">
        <SiteHeader />
        <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8 py-8 flex-1">
          <h1 className="font-playfair text-2xl sm:text-3xl text-white">My Account</h1>
          <nav aria-label="Account" className="mt-5 flex flex-wrap gap-2 border-b border-white/10 pb-3" data-testid="customer-account-nav">
            {CUSTOMER_NAV.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  data-testid={`account-nav-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className={({ isActive }) =>
                    `inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-colors outline-none focus-visible:ring-2 focus-visible:ring-gold ${
                      isActive ? "bg-gold/15 text-gold border border-gold/40" : "text-white/80 hover:text-white hover:bg-white/5 border border-transparent"
                    }`
                  }
                >
                  <Icon className="h-4 w-4" />
                  {item.label}
                </NavLink>
              );
            })}
          </nav>
          <div className="mt-8">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
